import { CheckCircle, Circle } from "@phosphor-icons/react";
import { SortBy } from "lib/types/discountAchiever";
import { TrayPopover } from "./TrayPopover";

export const SORT_OPTIONS: Array<{ value: SortBy; label: string }> = [
  { value: "GAP_CLOSING", label: "Relevance" },
  { value: "POPULARITY", label: "Popularity" },
  { value: "PRICE_DESC", label: "Price: High to Low" },
  { value: "PRICE_ASC", label: "Price: Low to High" },
];

export const getSortLabel = (sortBy: SortBy): string =>
  SORT_OPTIONS.find((option) => option.value === sortBy)?.label ?? "Sort";

interface SortSheetProps {
  open: boolean;
  value: SortBy;
  onSelect: (value: SortBy) => void;
  onClose: () => void;
}

export const SortSheet = ({ open, value, onSelect, onClose }: SortSheetProps) => (
  <TrayPopover open={open} title="Sort by" onClose={onClose}>
    <div className="flex flex-col">
      {SORT_OPTIONS.map((option) => {
        const isActive = option.value === value;
        return (
          <button
            key={option.value}
            type="button"
            onClick={() => onSelect(option.value)}
            className={`flex items-center gap-3 rounded-xl px-3 py-3 text-left ${
              isActive ? "bg-primary-lighter" : ""
            } hover:bg-shade-8 bg-shade-4`}>
            {isActive ? (
              <CheckCircle size={24} weight="fill" className="text-primary-dark " />
            ) : (
              <Circle
                size={24}
                className="text-zinc-300 "
              />
            )}
            <span
              className={
                isActive ? "text-text-sm-semibold text-coal-dark" : "text-text-sm-medium text-coal-light"
              }>
              {option.label}
            </span>
          </button>
        );
      })}
    </div>
  </TrayPopover>
);
